import PlusLabelDescription from './PlusLabelDescription';

export default PlusLabelDescription;
